export type SubscriptionPriceInput = {
  billingPrice: number;
  contractPrice?: number;
  discountedUnitPrice?: number;
};

export type ResolvedSubscriptionPrices = {
  billingPrice: number;
  contractPrice?: number;
  discountedBillingPrice?: number;
  discountedContractPrice?: number;
  hasDiscount: boolean;
};

export function yearlyContractPrice(monthlyPrice: number): number {
  return Math.round(monthlyPrice * 12 * 100) / 100;
}

/** Maps canonical BFF subscription prices to display amounts for labels and tiers. */
export function resolveSubscriptionPriceFields(
  input: SubscriptionPriceInput,
): ResolvedSubscriptionPrices {
  const { billingPrice, discountedUnitPrice } = input;
  const contractPrice =
    typeof input.contractPrice === 'number' && input.contractPrice > 0
      ? input.contractPrice
      : undefined;

  const hasDiscount =
    typeof discountedUnitPrice === 'number' &&
    discountedUnitPrice > 0 &&
    discountedUnitPrice < billingPrice;

  if (!hasDiscount) {
    return {
      billingPrice,
      contractPrice,
      hasDiscount: false,
    };
  }

  const discountedBillingPrice = discountedUnitPrice;
  const discountedContractPrice = yearlyContractPrice(discountedBillingPrice);

  return {
    billingPrice,
    contractPrice,
    discountedBillingPrice,
    discountedContractPrice,
    hasDiscount: true,
  };
}
